var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarylandLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 55,
    viewBox: "0 0 50 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5042 47.4323H34.0707V29.4415L27.8814 43.3961H21.8347L15.641 29.4371V47.4323H0.423828L4.40162 38.7028V9.82054L0.752426 0.0900879H15.0855L24.8527 22.6727L34.6285 0.0900879H48.901L45.3123 9.77083V38.692L49.5042 47.4323Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7507 46.3276H35.1774V24.2271L27.1657 42.2915H22.5566L14.5405 24.2228V46.3255H2.14014L5.50613 38.9406V9.61955L2.34552 1.19482H14.3567L24.8503 25.4528L35.3525 1.19482H47.3119L44.2074 9.57194V38.9427L47.7507 46.3276Z",
    fill: "#FFD520"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.473 45.5255L43.4032 39.1264V9.42707L46.1574 1.99683H35.88L24.8524 27.4763L13.8313 1.99683H3.50639L6.31247 9.47463L6.31031 39.1178L3.38965 45.5255H13.7341V20.433L23.0754 41.4893H26.6403L35.9795 20.4352V45.5255H46.473Z",
    fill: "#E31936"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6909 50.9841H36.0059L38.2239 52.4153V53.8702H40.9457L38.6909 52.3591V50.9841Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.227 51.9094L46.5272 53.4249V53.8702H47.7032L46.9963 53.3967V50.9841H43.7665V51.2392L43.3731 50.9841H40.9907V53.8702H44.227V51.9094Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1343 50.9841V52.4153V53.8702H35.9231V50.9841H33.1343Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0057 50.9841H35.9236V53.8702H38.2238V52.4153L36.0057 50.9841Z",
    fill: "#FFD520"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6907 50.9841V52.3591L40.9454 53.8702H40.9908V50.9841H38.6907Z",
    fill: "#FFD520"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7668 50.9841H43.3733L43.7668 51.2392V50.9841Z",
    fill: "#FFD520"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2273 51.9094V53.8702H46.5275V53.4249L44.2273 51.9094Z",
    fill: "#FFD520"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7035 53.8702H48.5293L47.5241 52.4023L48.5185 50.9841H46.9966V53.3967L47.7035 53.8702Z",
    fill: "#FFD520"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9293 52.4153C16.9293 51.9311 17.6406 51.5333 18.6199 51.4749C18.6588 51.2954 18.7128 51.1312 18.782 50.9841H16.8191V52.4153H16.9315H16.9293Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7263 51.3235V50.9819H20.4922C20.5419 51.0879 20.5851 51.2003 20.6197 51.3235H23.7263Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0005 52.4153C33.0005 52.9039 32.2915 53.2995 31.3122 53.3601C31.2711 53.5481 31.2127 53.7189 31.1414 53.8702H33.1367V52.4153H33.0005Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.167 53.5115V53.8703H29.4444C29.3925 53.7601 29.3449 53.6412 29.3082 53.5115H26.167Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6218 53.5115C20.585 53.6412 20.5375 53.7601 20.4856 53.8703H23.7262V53.5115H20.6196H20.6218Z",
    fill: "#E31936"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9293 52.4174V52.4153H16.8147V53.8702H18.7884C18.715 53.7189 18.6587 53.5481 18.6177 53.3601C17.6362 53.2995 16.9271 52.9017 16.9271 52.4174H16.9293Z",
    fill: "#E31936"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0007 52.4153H33.1368V50.9841H31.1501C31.2193 51.1312 31.2734 51.2954 31.3122 51.4749C32.2916 51.5333 32.9985 51.9332 33.0007 52.4153Z",
    fill: "#E31936"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3082 51.3235C29.3427 51.2003 29.386 51.0879 29.4357 50.9819H26.167V51.3235H29.3082Z",
    fill: "#E31936"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9294 52.4153C16.9294 52.4153 16.9294 52.4153 16.9294 52.4174C16.9294 52.9017 17.6385 53.2995 18.62 53.3601C18.6611 53.5481 18.7173 53.7189 18.7908 53.8702H20.4857C20.5376 53.76 20.5851 53.6411 20.6219 53.5114H23.7284V53.8702H24.9499V52.4153H16.9316H16.9294Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0006 52.4174L24.9478 52.4153V53.8702H26.167V53.5114H29.3082C29.345 53.6411 29.3903 53.76 29.4444 53.8702H31.1393C31.2128 53.7189 31.269 53.5481 31.3101 53.3601C32.2916 53.2995 32.9984 52.9017 32.9984 52.4174H33.0006Z",
    fill: "#E31936"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0007 52.4153C32.9985 51.9332 32.2894 51.5333 31.3123 51.4749C31.2734 51.2954 31.2193 51.1312 31.1501 50.9841H29.438C29.3882 51.0901 29.345 51.2025 29.3104 51.3257H26.1693V50.9841H24.95V52.4153H33.0028H33.0007Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9294 52.4153H24.9477V50.9841H23.7263V51.3257H20.6197C20.5851 51.2025 20.5418 51.0901 20.4921 50.9841H18.78C18.7108 51.1312 18.6567 51.2954 18.6178 51.4749C17.6385 51.5333 16.9294 51.9332 16.9272 52.4153H16.9294Z",
    fill: "#E31936"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41413 50.9841L2.41074 52.4002L1.40332 53.8702H3.26034V50.9841H1.41413Z",
    fill: "#231F20"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3395 50.9841H11.1075V51.2392L10.7141 50.9841H8.32959V53.8702H11.5681V51.9094L13.8682 53.4249V53.8702H15.0464L14.3395 53.3967V50.9841Z",
    fill: "#231F20"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02919 50.9841H3.34204L5.55793 52.4153V53.8702H8.28618L6.02919 52.3591V50.9841Z",
    fill: "#231F20"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34192 50.9841H3.25977V53.8702H5.55781V52.4153L3.34192 50.9841Z",
    fill: "#FFD520"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02905 50.9841V52.3591L8.28604 53.8702H8.32922V50.9841H6.02905Z",
    fill: "#FFD520"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1073 50.9841H10.7139L11.1073 51.2392V50.9841Z",
    fill: "#FFD520"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5679 51.9094V53.8702H13.8681V53.4249L11.5679 51.9094Z",
    fill: "#FFD520"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8169 50.9841H14.3394V53.3967L15.0463 53.8702H16.8125L16.8147 52.4153L16.8169 50.9841Z",
    fill: "#FFD520"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9299 54.6356H0L1.32089 52.4046L0.00432369 50.2168H49.9278L48.609 52.4046L49.9278 54.6378L49.9299 54.6356ZM1.40303 53.8703H48.529L47.5238 52.4024L48.5204 50.9842H1.41385L2.41045 52.4003L1.40303 53.8703Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarylandLogo2);
export default __webpack_public_path__ + "static/media/maryland_logo2.639586655d8a26cc4c09551ec4f6ebad.svg";
export { ForwardRef as ReactComponent };